import { recoverSession } from '@/lib/auth/sessionRecovery'

/**
 * Fetch that retries once after recovering the session.
 *
 * Only a 401 is retried. A 403 means the server understood who you are and
 * refused anyway - a new token cannot change that, and refreshing on 403 was
 * one of the three uncoordinated refresh paths behind the 2026-08-28 loop.
 */
export async function fetchWithAuthRetry(url: string, options?: RequestInit): Promise<Response> {
  const response = await fetch(url, options)
  if (response.status !== 401) return response

  const recovered = await recoverSession()
  if (!recovered) return response

  return fetch(url, options)
}
